module.exports = __webpack_public_path__ + "img/HQ-Z7020-V3.a8742993.png";